/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-const-assign */
import { useState, useEffect, useContext, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import InquiryService from 'services/inquiry';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import CommonFns from 'functions/common.ts';
import Big from 'big.js';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InfoIcon from '@material-ui/icons/Info';
import Drawer from '@material-ui/core/Drawer';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import OrderLogList from 'components/orderLogList';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Public from '../public';
import BodydCustField from 'components/bodyCustField';
import CustFieldService from 'services/custField';

function InquiryBidMultiDetail(props) {
  const Config = {
    purchase: {
      title: '供应商竞价详情',
      apiPath: '/bidding/getDetail',
      publishApiPath: '/bidding/publish',
      cancelApiPath: '/bidding/cancel',
      puResultApiPath: '/bidding/publishResult',
      confirmCuBidApiPath: '/cbidding/biddingChoose',
      enumMainKey: 'B02_Bid_Status',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/inquiry/prod/quote/detail',
      custFieldBillType: 84, //自定义字段单别
      arrEnumField: [
        {
          mainKey: 'B02_Bid_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'bidXkNo',
      wfmCode: '1029'
    },
    sale: {
      title: '客户竞价详情',
      apiPath: '/cbidding/getDetail',
      enumMainKey: 'B02_Bid_Status',
      companyNameKey: 'innerCustomerName',
      confirmCuBidApiPath: '/cbidding/biddingChoose',
      detailLink: '/mp/sale/inquiry/prod/quote/detail',
      addLink: '/mp/sale/inquiry/prod/quote/add',
      quPriceBidApiPath: '/cbidding/quote/add',
      custFieldBillType: 84, //自定义字段单别
      arrEnumField: [
        {
          mainKey: 'B02_Bid_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'bidXkNo'
    }
  };

  const styles = theme => ({
    quoteBt: {
      height: 32,
      borderRadius: '4px',
      marginTop: 10,
      float: 'right'
    }
  });

  const { state, dispatch } = useContext(ActionContext);
  const config = Config[props.type];
  config.dispatch = dispatch;

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    handleMore,
    decimalPlace,
    fieldSetting,
    fileList,
    setShowLoading,
    setError,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);
  self.idField = 'bidXkNo';
  self.countTimer = 0;
  self.countDownTimer = 0;

  // const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });

  const [currentBidInfo, setCurrentBidInfo] = useState({});
  const [vendorQuoteList, setVendorQuoteList] = useState([]);
  const [myQuoteList, setMyQuoteList] = useState([]);
  const [countDown, setCountDown] = useState();
  const [currNavIndex, setCurrNavIndex] = useState(Number);
  const [quoteBottom, setQuoteBottom] = useState(false);
  const [historyBottom, setHistoryBottom] = useState(false);

  const [paramVar, setParamVar] = useState({});
  const [myQuotePrice, setMyQuotePrice] = useState(Number);
  const [vendorDescription, setVendorDescription] = useState('');
  const [primaryQuoteData, setPrimaryQuoteData] = useState({});
  const [taxTypeList, setTaxTypeList] = useState([]);

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (self.isPurchase) {
      data.vendorList.forEach(vendor => {
        EnumService.getValue(
          'B02_Bid_Confirm_Flag',
          vendor.confirmBiddingFlag
        ).then(value => {
          vendor.confirmBiddingFlagName = value;
          forceUpdate();
        });
      });
    } else {
      EnumService.getValue(
        'B02_Bid_Confirm_Flag',
        data.confirmBiddingFlag
      ).then(value => {
        data.confirmBiddingFlagName = value;
        forceUpdate();
      });
      getSelectList(data);
    }

    data.taxRateShow = data.taxRate * 100;
    data.priceContainTaxName =
      data.priceContainTaxFlag === 0
        ? '不限'
        : data.priceContainTaxFlag === 1
          ? '含税价'
          : '未税价';
    data.quoteCurrencyName = data.quoteCurrencyName || '人民币'; //默认人民币
    setDetail(data);
    // refreshQuoteData(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  // 修改useEffect中的比较逻辑
  useEffect(() => {
    const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
    if (detail.bidXkNo && !isEqual(prevDetail.current, detail)) {
      refreshQuoteData(detail);
      prevDetail.current = { ...detail };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail]); // 只需监听detail对象

  // 在组件顶部新增ref
  const prevDetail = useRef({});

  // 新增专门管理定时器的useEffect
  useEffect(() => {
    return () => {
      if (refreTimeObj.current) {
        clearInterval(refreTimeObj.current);
      }
      if (self.countDownTimer) {
        clearInterval(self.countDownTimer);
      }
    };
  }, [self]); // 空依赖数组表示只在组件卸载时执行

  useEffect(() => {
    if (detail?.bidEndDate && detail.status === 2) {
      const timer = setInterval(() => {
        const delta = Math.floor((detail.bidEndDate - Date.now()) / 1000);
        if (delta < 0) {
          setCountDown('00 : 00 : 00');
          clearInterval(timer);
          return;
        }

        const pad = n => n.toString().padStart(2, '0');
        const h = Math.floor(delta / 3600);
        const m = Math.floor((delta % 3600) / 60);
        const s = delta % 60;

        setCountDown(`${pad(h)} : ${pad(m)} : ${pad(s)}`);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [detail?.bidEndDate, detail?.status]); // 添加关键依赖项

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  // 获取参数列表（税别）
  function getSelectList(detailData) {
    let postbodyTaxType = {
      apiPath: '/archives/compTaxType/getListByCompCode',
      companyCode: detailData.customerCode
    };

    let arrPromise = [Http.post('/api/cloudCenter', postbodyTaxType)];

    Promise.all(arrPromise).then(arrResponse => {
      let responseTax = arrResponse[0]; // 税别
      let taxTypeList1 = [];

      if (responseTax.success) {
        taxTypeList1 = responseTax.data.map(item => {
          let text = '(' + item.taxCode + ') ' + item.taxName;
          return {
            id: item.taxCode,
            name: item.taxName,
            text: text,
            taxRate: item.taxRate,
            isContainTax: item.isContainTax,
            taxName: item.taxName
          };
        });
      }
      setTaxTypeList(taxTypeList1);
    });
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      bidXkNo: detail.bidXkNo,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  // 切换tab
  function handleNav(event, type) {
    setCurrNavIndex(Number(type));
    if (Number(type) === 1 || Number(type) === 0) {
      refreshQuoteData(detail);
    } else {
      clearInterval(self.countTimer);
      clearInterval(self.countDownTimer);
    }

    if (
      Number(type) === 1 &&
      [3, 4, 5, 6, 7, 8, 9].includes(detail.status) &&
      self.isPurchase
    ) {
      getCompareList();
    }
  }

  let refreTimeObj = useRef();

  // 项目竞价
  function refreshQuoteData(data) {
    if (self.refreshLock) {
      return;
    } // 添加执行锁
    self.refreshLock = true;
    clearInterval(refreTimeObj.current);
    clearInterval(self.countDownTimer);

    let fn = async () => {
      if (self.isPurchase) {
        if (!data.lastQueryTime) {
          await getCurrentBidInfo(data);
          await getQuoteDetail(data);
        }
        if (await getIsHaveNewQuote(data)) {
          clearInterval(self.countDownTimer);
          await getCurrentBidInfo(data);
          await getQuoteDetail(data);
          // await initCountDown(data);
        }
      } else {
        if (!data.lastQueryTime) {
          getMyQuoteList(data);
          getBidStatistics(data);
          getQuoteDetailSale(data);
        }
        if (await getIsHaveNewQuote(data)) {
          clearInterval(self.countDownTimer);
          getMyQuoteList(data);
          getBidStatistics(data);
          getQuoteDetailSale(data);
        }
      }
    };

    if (data.status !== 1) {
      fn();
    }
    if (data.status === 2) {
      // 保留原有定时器逻辑，但增加有效性校验
      refreTimeObj.current = setInterval(fn, 1000);
    }

    setTimeout(() => {
      self.refreshLock = false; // 300ms后释放锁
    }, 300);
  }

  // 获取当前价格统计
  function getCurrentBidInfo(detailData) {
    let postbody = {
      bidXkNo: detailData.bidXkNo,
      bidLineNo: 1,
      companyCode: companyCode,
      apiPath: '/bidding/quote/currentBidInfo'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      let format = n => {
        let prefix = n > 0 ? '+' : '';
        return prefix + n.toFixed(0) + '%';
      };
      if (response.success) {
        let data = response.data || {};
        let n;
        if (data.currMinPrice !== null && data.histoMinPrice !== null) {
          n =
            ((data.currMinPrice - data.histoMinPrice) / data.histoMinPrice) *
            100;
          data.percentMin = format(n);
          data.deltaMin = data.currMinPrice - data.histoMinPrice;
        }
        if (data.currAvgPrice !== null && data.histoAvgPrice !== null) {
          n =
            ((data.currAvgPrice - data.histoAvgPrice) / data.histoAvgPrice) *
            100;
          data.percentAvg = format(n);
          data.deltaAvg = data.currAvgPrice - data.histoAvgPrice;
        }
        if (data.currMaxPrice !== null && data.histoMaxPrice !== null) {
          n =
            ((data.currMaxPrice - data.histoMaxPrice) / data.histoMaxPrice) *
            100;
          data.percentMax = format(n);
          data.deltaMax = data.currMaxPrice - data.histoMaxPrice;
        }
        if (data.bidEndDate) {
          // 创建新对象触发重新渲染
          const newDetail = { ...detailData, bidEndDate: data.bidEndDate };
          setDetail(newDetail);
        }

        setCurrentBidInfo(data);
      }
    });
  }

  // 获取报价详情
  function getQuoteDetail(data) {
    let postbody = {
      bidXkNo: data.bidXkNo,
      callerType: 1,
      companyCode: companyCode,
      apiPath: '/bidding/quote/getQuoteDetail'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let arr = response.data || [];
        //[比价中，已完成]
        if ([4, 5].includes(data.status)) {
          //根据最终价格排序
          let list = arr
            .filter(item => item.quoteList !== null)
            .sort((a, b) => b.createtime - a.createTime)
            .sort(
              (a, b) => a.quoteList[0].quotePrice - b.quoteList[0].quotePrice
            );

          genFinalQuoteList(list);
          setVendorQuoteList(list);
        } else if (detail.status === 2) {
          setVendorQuoteList(arr);
        }
      }
    });
  }

  //当前竞价统计信息（供应商）
  async function getBidStatistics(data) {
    let postbody = {
      bidXkNo: data.bidXkNo,
      companyCode: companyCode,
      apiPath: '/cbidding/quote/currentBidStatistics'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data.respList || [];
        if (list?.length) {
          data.prodList.forEach(prod => {
            prod.currQuoteList = list.filter(
              item => item.lineNo === prod.lineNo
            )[0];
            let fieldList = [
              'rank',
              'currMinPrice',
              'lastPrice',
              'taxName',
              'taxCode',
              'taxPrice',
              'unTaxPrice',
              'vendorDescription',
              'quoteSelectedFlag',
              'priceSize'
            ];
            for (let i = 0; i < fieldList.length; i++) {
              if (prod.currQuoteList) {
                prod[fieldList[i]] = prod.currQuoteList[fieldList[i]];
              }
            }
          });
          if (response.data.bidEndDate) {
            data.bidEndDate = response.data.bidEndDate;
          }
          setDetail(data);
        }
      }
    });
  }

  // 获取我的报价列表（供应商）
  function getMyQuoteList(data) {
    let postbody = {
      bidXkNo: data.bidXkNo,
      companyCode: companyCode,
      apiPath: '/cbidding/quote/myQuoteList'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data || [];
        if (list?.length) {
          data.prodList.forEach(prod => {
            prod.quoteList = list.filter(
              item => item.bidLineNo === prod.lineNo
            );
          });
          setDetail(data);
        }
        forceUpdate();
        setMyQuoteList(list);
      }
    });
  }

  // 获取当前价格统计（供应商）
  function getCurrentBidInfoSale(detailData) {
    let postbody = {
      bidXkNo: detailData.bidXkNo,
      bidLineNo: 1,
      companyCode: companyCode,
      apiPath: '/cbidding/quote/currentBidInfo'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data || {};
        setCurrentBidInfo(data);
      }
    });
  }
  // 获取报价详情（供应商）
  function getQuoteDetailSale(detailData) {
    let postbody = {
      bidXkNo: detailData.bidXkNo,
      callerType: 2,
      companyCode: companyCode,
      apiPath: '/bidding/quote/getQuoteDetail'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data || [];
        list.forEach(item => {
          item.isSelf = item.vendorCode === self.companyCode;
        });
        setVendorQuoteList(list);
      }
    });
  }
  //生成最终报价数据
  function genFinalQuoteList(list) {
    let total = 0;
    let arr = list
      .filter(vendor => vendor.quoteList !== null)
      .map(vendor => {
        let quoteList = vendor.quoteList
          .slice(0)
          .sort((a, b) => b.createTime - a.createTime);
        let { quotePrice } = quoteList[0];
        total += quotePrice;
        return {
          quotePrice: '',
          createName: '',
          vendorCode: '',
          avgPrice: 0,
          checked: vendor.quoteSelectedFlag === 1,
          innerVendorName: vendor.innerVendorName,
          vendorXkUniqueCode: vendor.vendorXkUniqueCode
        };
      });
    arr.sort((a, b) => a.quotePrice - b.quotePrice);
  }

  // 修改initCountDown函数
  // function initCountDown() {
  //   clearInterval(self.countDownTimer); // 清除旧定时器

  //   const updateFn = () => {
  //     // 每次从最新detail获取时间
  //     const currentDate = detail.bidEndDate;
  //     if (!currentDate) {
  //       setCountDown('-- : -- : --');
  //       return;
  //     }

  //     const delta = Math.floor((currentDate - Date.now()) / 1000);
  //     if (delta < 0) {
  //       clearInterval(self.countDownTimer);
  //       setCountDown('00 : 00 : 00');
  //       return;
  //     }

  //     const padZero = n => n.toString().padStart(2, '0');
  //     const h = Math.floor(delta / 3600);
  //     const m = Math.floor((delta % 3600) / 60);
  //     const s = Math.floor(delta % 60);

  //     setCountDown(`${padZero(h)} : ${padZero(m)} : ${padZero(s)}`);
  //   };

  //   // 立即执行并启动定时器
  //   updateFn();
  //   self.countDownTimer = setInterval(updateFn, 1000);
  // }

  //打开报价弹窗初始化数据
  function setDate(item) {
    setQuoteBottom(true);
    setPrimaryQuoteData(item);
    let obj = {};

    if (!Util.isEmpty(item.currQuoteList)) {
      obj = {
        taxCode: item.currQuoteList.taxCode || detail.taxCode,
        taxName: item.currQuoteList.taxName || detail.taxName,
        isContainTax: item.currQuoteList.isContainTax || detail.isContainTax,
        taxRate: item.currQuoteList.taxRate || detail.taxRate
      };
    } else {
      let isContainTax = 1;
      if (taxTypeList.some(tax => tax.id === detail.taxCode)) {
        isContainTax = taxTypeList.filter(tax => tax.id === detail.taxCode)[0]
          .isContainTax;
      }
      obj = {
        taxCode: detail.taxCode,
        taxName: detail.taxName,
        isContainTax: isContainTax,
        taxRate: detail.taxRate
      };
    }
    // let bodyData = CustFieldService.getBodyData(
    //   fieldSetting,
    //   item,
    //   self.isPurchase
    // );
    setMyQuotePrice(0);
    setParamVar({
      ...item,
      quotePrice: myQuotePrice,
      vendorDescription: vendorDescription,
      isBackTxtError: false,
      isBackTxtError2: false,
      quotePriceTax: 0,
      quotePriceNoTax: 0,
      taxCode: obj.taxCode,
      taxName: obj.taxName,
      isContainTax: obj.isContainTax,
      taxRate: obj.taxRate
    });
  }

  // 修改报价信息
  function handleQuoteChange(event) {
    let val = Util.qtyChange(event.target.value);
    setMyQuotePrice(val);
    forceUpdate();
    calculatePrice(val);
  }

  //修改税别
  function handleTaxTypeChange(event) {
    let val = event.target.value;
    let obj = paramVar;
    obj['taxCode'] = val;
    taxTypeList.forEach(item => {
      if (item.id === val) {
        obj['taxName'] = item.taxName;
        obj['isTaxRate'] = item.taxRate;
        obj['taxRate'] = item.taxRate;
        obj['taxRateShow'] = item.taxRate * 100;
        obj['isContainTax'] = item.isContainTax;
        obj['priceContainTaxFlag'] = item.isContainTax === 1 ? 1 : 2;
        obj['priceContainTaxName'] =
          obj.priceContainTaxFlag === 0
            ? '不限'
            : obj.priceContainTaxFlag === 1
              ? '含税价'
              : '未税价';
      }
    });
    setParamVar({
      ...obj,
      quotePrice: myQuotePrice,
      vendorDescription: vendorDescription,
      isBackTxtError: false,
      isBackTxtError2: false,
      quotePriceTax: paramVar.quotePriceTax,
      quotePriceNoTax: paramVar.quotePriceNoTax,
      taxCode: obj.taxCode,
      taxName: obj.taxName,
      isContainTax: obj.isContainTax,
      taxRate: obj.taxRate
    });
    forceUpdate();
    calculatePrice(myQuotePrice);
  }

  //计算项次的含税单价和未税单价
  function calculatePrice(val) {
    let quotePrice = val;
    let taxRate = paramVar.taxRate || 0;
    if (!Util.isEmpty(quotePrice) && Util.isBig(quotePrice, taxRate)) {
      if (paramVar.isContainTax === 0) {
        paramVar.quotePriceNoTax = quotePrice;
        paramVar.quotePriceTax =
          Big(parseFloat(paramVar.quotePriceNoTax))
            .times(Big(taxRate).plus(1))
            .valueOf() || 0;
        paramVar.quotePriceTax = Big(paramVar.quotePriceTax).toFixed(8);
      } else {
        paramVar.quotePriceTax = quotePrice;
        paramVar.quotePriceNoTax =
          Big(parseFloat(paramVar.quotePriceTax))
            .div(Big(taxRate).plus(1))
            .valueOf() || 0;
        paramVar.quotePriceNoTax = Big(paramVar.quotePriceNoTax).toFixed(8);
      }
    } else {
      paramVar.quotePriceTax = 0;
      paramVar.quotePriceNoTax = 0;
    }

    setParamVar({
      ...paramVar,
      quotePrice: quotePrice,
      vendorDescription: vendorDescription,
      isBackTxtError: false,
      isBackTxtError2: false,
      quotePriceTax: paramVar.quotePriceTax,
      quotePriceNoTax: paramVar.quotePriceNoTax,
      taxCode: paramVar.taxCode,
      taxName: paramVar.taxName,
      isContainTax: paramVar.isContainTax,
      taxRate: paramVar.taxRate
    });
    forceUpdate();
  }

  // 修改描述信息
  function handleVendorDescriptionChange(event) {
    let val = event.target.value;
    setVendorDescription(val);

    setParamVar({
      ...paramVar,
      quotePrice: myQuotePrice,
      vendorDescription: vendorDescription,
      isBackTxtError: false,
      isBackTxtError2: false,
      quotePriceTax: paramVar.quotePriceTax,
      quotePriceNoTax: paramVar.quotePriceNoTax,
      taxCode: paramVar.taxCode,
      taxName: paramVar.taxName,
      isContainTax: paramVar.isContainTax,
      taxRate: paramVar.taxRate
    });
  }

  // 确定报价按钮
  function sureQuoteClick() {
    let list = myQuoteList.filter(
      item => item.bidLineNo === primaryQuoteData.lineNo
    );
    let lastPrice = list.length > 0 ? list[0].quotePrice : Infinity;
    if (/^\d+(\.\d+)?$/.test(myQuotePrice) === false) {
      setParamVar({ isBackTxtError: true, isBackTxtError2: false });
      return;
    }
    if (detail.quoteLessFlag === 1 && parseFloat(myQuotePrice) >= lastPrice) {
      setParamVar({ isBackTxtError: false, isBackTxtError2: true });
      return;
    }
    handle('quotePrice');
  }

  function handle(type) {
    switch (type) {
      case '1':
        confirmCustomerBidding(1);
        break;
      case '2':
        confirmCustomerBidding(2);
        break;
      case '3':
        publishBidding();
        break;
      case '4':
        cancelBidding();
        break;
      case '5':
        publishResult();
        break;
      case 'quotePrice':
        quotePriceBidding();
        break;
      default:
    }
  }

  // 发布竞价
  function publishBidding() {
    let postbody = getPostbody(config.publishApiPath);
    InquiryService.publishBidding(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  // 取消竞价
  function cancelBidding() {
    let postbody = getPostbody(config.cancelApiPath);
    InquiryService.cancelBidding(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  // 发布竞价结果
  function publishResult() {
    let postbody = getPostbody(config.puResultApiPath);
    InquiryService.publishResult(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  // 供应商确认竞价 || 放弃
  function confirmCustomerBidding(type) {
    let postbody = getPostbody(config.confirmCuBidApiPath);
    postbody.confirmBiddingFlag = type;
    InquiryService.confirmCustomerBidding(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  // 报价
  function quotePriceBidding() {
    let postbody = getPostbody(config.quPriceBidApiPath);
    postbody.bidLineNo = primaryQuoteData.lineNo;
    postbody.quotePrice = paramVar.quotePrice;
    postbody.vendorDescription = vendorDescription;
    postbody.taxCode = paramVar.taxCode;
    postbody.taxName = paramVar.taxName;
    postbody.taxRate = paramVar.taxRate;
    postbody.isContainTax = paramVar.isContainTax;

    let bodyData = CustFieldService.getBodyData(
      fieldSetting,
      paramVar,
      self.isPurchase
    );

    CustFieldService.parseCustFields(
      fieldSetting,
      undefined,
      [bodyData],
      self.isPurchase
    );

    if (
      !CustFieldService.validate(
        undefined,
        [bodyData],
        fieldSetting,
        false,
        dispatch
      )
    ) {
      return;
    }

    Object.assign(postbody, bodyData);

    InquiryService.quotePriceBidding(
      postbody,
      () => {
        // self.getDetail();
        setMyQuotePrice('');
        setQuoteBottom(false);
        refreshQuoteData(detail);
      },
      dispatch
    );
  }

  // 报价对比
  function handleDrawer(item) {
    item.activeFlag = !item.activeFlag;
    forceUpdate();
  }

  //获取报价对比列表
  //viewType 视图类型 1：物料模式, 2:供应商模式  默认：物料模式
  function getCompareList() {
    let postbody = {
      companyCode: companyCode,
      bidXkNo: detail.bidXkNo,
      orderProperty: 'createTime',
      ascOrDesc: 'desc',
      viewType: 1,
      apiPath: '/bidding/quote/compareQuotesPrint'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        if (
          !response.data?.list ||
          (Array.isArray(response.data?.list) &&
            response.data?.list.length === 0)
        ) {
          ModalService.showInfo('暂无报价记录', dispatch);
          return;
        }
        let data = response.data?.list || [];
        data.forEach(item => {
          item.quoteList = item.quoteList || [];
          item.quoteList.forEach(row => {
            if (Util.isBig(row.prcDownPriceRate)) {
              row.prcDownPriceRateShow = Big(row.prcDownPriceRate)
                .times(100)
                .toFixed(2)
                .valueOf();
            }
          });
        });
        detail.quoteCompareList = data;
        setDetail(detail);
        forceUpdate();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }
  //获取当前价格统计
  async function getIsHaveNewQuote(data) {
    if (!data.lastQueryTime) {
      data.lastQueryTime = Public.getServerTime();
    }

    let time = data.lastQueryTime || Public.getServerTime();

    let haveNewQuote = false;
    let postbody = {
      bidXkNo: data.bidXkNo,
      lastQueryTime: time,
      bidEndDate: detail.bidEndDate,
      companyCode: self.isPurchase ? companyCode : data.customerCode,
      apiPath: '/bidding/quote/getIsHaveNewQuote'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        haveNewQuote = response.data;
        data.lastQueryTime = response.curServerTime;
        setDetail(data);
      }
    });
    return haveNewQuote;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      {detail.status > 1 && (
        <Paper square={true} style={{ marginBottom: '5px' }}>
          <Tabs
            value={currNavIndex}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleNav}
          >
            <Tab label="项目信息" />
            {[3, 4, 5, 6, 7, 8, 9].includes(detail.status) &&
              self.isPurchase && <Tab label="报价对比" />}
            {/* {[1, 2, 4, 5].includes(detail.status) &&
              (self.isPurchase ||
                (!self.isPurchase && detail.confirmBiddingFlag === 1)) && (
                <Tab label={'项目竞价(' + detail.statusName + ')'} />
              )} */}
            <Tab label="操作记录" />
          </Tabs>
        </Paper>
      )}
      {currNavIndex === 0 && (
        <div className="m-details-container">
          <div className="m-details-item">
            <div className="details-item-title">
              <label>基础信息</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">标题</span>
                    <div className="field-value">{detail.billTitle}</div>
                  </li>
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">客户</span>
                      <div className="field-value">
                        {detail.innerCustomerName}
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">竞价状态</span>
                    <div className="field-value">
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'B02_Bid_Status',
                            detail.status
                          )
                        }
                      >
                        {detail.statusName}
                      </span>
                    </div>
                  </li>
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">确认状态</span>
                      <div className="field-value">
                        <span
                          className={
                            detail.confirmBiddingFlag === 1
                              ? 'green'
                              : detail.confirmBiddingFlag === 2
                                ? 'red'
                                : ''
                          }
                        >
                          {detail.confirmBiddingFlagName}
                        </span>
                      </div>
                    </li>
                  )}
                  {/* 审批流状态 仅开启后才显示 */}
                  {workflow.isActive && (
                    <li>
                      <span className="field-label">审批环节</span>
                      <div className="field-value">
                        <WorkflowStatus
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                        />
                      </div>
                    </li>
                  )}
                  {/* 审批流按钮 */}
                  {self.isPurchase && workflow.isActive && (
                    <li>
                      <span className="field-label">审批操作</span>
                      <div className="field-value">
                        <WorkflowButtons
                          companyCode={companyCode}
                          id={detail.bidXkNo}
                          workflow={workflow}
                          detail={detail}
                          onChange={() => {
                            self.getDetail();
                          }}
                        />
                      </div>
                    </li>
                  )}
                  {!self.isPurchase && detail.status === 5 && (
                    <li>
                      <span className="field-label">竞价结果</span>
                      <div className="field-value">
                        <span
                          className={
                            [1, 2].includes(detail.quoteSelectedFlag)
                              ? 'green'
                              : detail.quoteSelectedFlag === 0
                                ? 'orange'
                                : ''
                          }
                        >
                          {detail.quoteSelectedFlag === 2
                            ? '全部入选'
                            : detail.quoteSelectedFlag === 1
                              ? '部分入选'
                              : detail.quoteSelectedFlag === 0
                                ? '未入选'
                                : ''}
                        </span>
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">发布时间</span>
                    <div className="field-value">
                      {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">发布人</span>
                    <div className="field-value">{detail.publishName}</div>
                  </li>
                  <li>
                    <span className="field-label">编号</span>
                    <div className="field-value">{detail.bidXkNo}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>竞价项目设定</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">竞价有效时间</span>
                    <div className="field-value">
                      <span className="blue">
                        {formatDate(detail.bidStartDate, 'YYYY-MM-DD HH:mm')} -{' '}
                        {formatDate(detail.bidEndDate, 'YYYY-MM-DD  HH:mm')}
                      </span>
                    </div>
                  </li>
                  {/* 未开始 */}
                  {detail.status === 1 && (
                    <li className="orange">
                      <span className="field-label">未开始</span>
                      <div className="field-value">
                        开始时间：
                        {formatDate(detail.bidStartDate, 'YYYY-MM-DD HH:mm:ss')}
                      </div>
                    </li>
                  )}
                  {/* 距离竞价截止时间 */}
                  {detail.status === 2 && (
                    <li className="orange">
                      <span className="field-label">距离竞价截止时间</span>
                      <div className="field-value">{countDown}</div>
                    </li>
                  )}
                  {/* 已结束 */}
                  {[4, 5].includes(detail.status) && (
                    <li className="orange">
                      <span className="field-label">已结束</span>
                      <div className="field-value">
                        结束时间：
                        <span>
                          {formatDate(detail.bidEndDate, 'YYYY-MM-DD HH:mm:ss')}
                        </span>
                      </div>
                    </li>
                  )}
                  {/* 竞价控制 */}
                  {self.isPurchase && (
                    <li>
                      <span className="field-label">竞价控制</span>
                      <div className="field-value">
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showRankingsFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示排名"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showMaxPriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示最高报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showMinPriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示最低报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showAveragePriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示平均报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showVendorPriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示其他供应商报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showOtherVendorNameFlag === 1
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="竞价时公示其他供应商名称"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.quoteLessFlag === 1 ? true : false
                              }
                            />
                          }
                          label="报价时价格必须低于上次报价"
                        />
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>报价要求</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">付款方式</span>
                    <div className="field-value">{detail.payWayName}</div>
                  </li>
                  <li>
                    <span className="field-label">付款周期</span>
                    <div className="field-value">{detail.paymentCycleName}</div>
                  </li>
                  <li>
                    <span className="field-label">报价币别</span>
                    <div className="field-value">
                      {detail.quoteCurrencyName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">是否含税</span>
                    <div className="field-value">
                      {detail.priceContainTaxName}
                    </div>
                  </li>
                  {detail.priceContainTaxFlag && detail.taxRateShow ? (
                    <li>
                      <span className="field-label">税率</span>
                      <div className="field-value">{detail.taxRateShow}%</div>
                    </li>
                  ) : (
                    ''
                  )}
                  <li>
                    <span className="field-label">竞价说明</span>
                    <div className="field-value">{detail.description}</div>
                  </li>
                  {detail.description && (
                    <li>
                      <div className="field-value">
                        <div className="quoProductsList wid100">
                          <InfoIcon
                            className="verticalMiddle mr5"
                            color="primary"
                            fontSize="small"
                          />
                          参与竞价即代表已经同意上述报价要求
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>竞价物料</label>
            </div>
            <div className="details-item-content">
              {!Util.isEmpty(detail.prodList) &&
                detail.prodList.map((item, index) => (
                  <div
                    className="content-line line-list-item"
                    key={String(item.id) + index}
                  >
                    <div className="line-list-item-title">
                      <span>项次 {item.lineNo}</span>
                    </div>
                    <ul className="field-list">
                      <li>
                        <span className="field-label">物料编码</span>
                        <div className="field-value">{item.productCode}</div>
                      </li>
                      <li>
                        <span className="field-label">物料名称</span>
                        <div className="field-value">{item.productName}</div>
                      </li>
                      <li>
                        <span className="field-label">物料规格</span>
                        <div className="field-value">{item.productScale}</div>
                      </li>
                      <li>
                        <span className="field-label">采购数量</span>
                        <div className="field-value">
                          {formatNumber(
                            item.purchaseQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}{' '}
                          {item.purchaseUnitName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">采购单位</span>
                        <div className="field-value">{item.unitName}</div>
                      </li>
                      <li>
                        <span className="field-label">送货地址</span>
                        <div className="field-value">
                          <p>{item.deliveryPlaceName}</p>
                          <p>{item.detailedAddress}</p>
                        </div>
                      </li>
                      <li>
                        <span className="field-label">需求日期</span>
                        <div className="field-value">
                          {formatDate(item.demandDate, 'YYYY-MM-DD')}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">相关说明</span>
                        <div className="field-value">{item.description}</div>
                      </li>
                    </ul>
                    {self.isPurchase &&
                      !Util.isEmpty(item.respList) &&
                      item.respList.map((prod, prodIndex) => (
                        <div className="order-detail-more" key={prodIndex}>
                          {prod.priceSize && (
                            <ul key={prodIndex} className="field-list">
                              <li>
                                <span className="field-label">供应商名称</span>
                                <div className="field-value">
                                  {prod.innerVendorName}
                                </div>
                              </li>
                              <li>
                                <span className="field-label">初次报价</span>
                                <div className="field-value">
                                  {formatNumber(
                                    prod.firstPrice,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                </div>
                              </li>
                              <li>
                                <span className="field-label">报价次数</span>
                                <div className="field-value">
                                  {prod.priceSize}
                                </div>
                              </li>
                              <li>
                                <span className="field-label">报价排名</span>
                                <div className="field-value">{prod.rank}</div>
                              </li>
                              <li>
                                <span className="field-label">最新报价</span>
                                <div className="field-value">
                                  {formatNumber(
                                    prod.lastPrice,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                </div>
                              </li>
                              <li>
                                <span className="field-label">备注说明</span>
                                <div className="field-value">
                                  {prod.vendorDescription}
                                </div>
                              </li>
                            </ul>
                          )}
                        </div>
                      ))}

                    {!self.isPurchase && (
                      <div className="order-detail-more">
                        {
                          <ul className="field-list">
                            <li>
                              <span className="field-label">报价排名</span>
                              <div className="field-value">{item.rank}</div>
                            </li>
                            <li>
                              <span className="field-label">报价次数</span>
                              <div className="field-value">
                                {item.priceSize}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">最低价</span>
                              <div className="field-value">
                                {formatNumber(
                                  item.currMinPrice,
                                  decimalPlace.Price_Decimal_Place
                                )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">当前报价</span>
                              <div className="field-value">
                                {formatNumber(
                                  item.lastPrice,
                                  decimalPlace.Price_Decimal_Place
                                )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">报价税别</span>
                              <div className="field-value">{item.taxName}</div>
                            </li>
                            <li>
                              <span className="field-label">含税价</span>
                              <div className="field-value">
                                {formatNumber(
                                  item.taxPrice,
                                  decimalPlace.Price_Decimal_Place
                                )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">未税价</span>
                              <div className="field-value">
                                {formatNumber(
                                  item.unTaxPrice,
                                  decimalPlace.Price_Decimal_Place
                                )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">备注说明</span>
                              <div className="field-value">
                                {item.vendorDescription}
                              </div>
                            </li>
                            {detail.status === 5 && (
                              <li>
                                <span className="field-label">竞价结果</span>
                                <div className="field-value">
                                  <span
                                    className={
                                      'u-sign ' +
                                      (item.quoteSelectedFlag === 0
                                        ? 'orange'
                                        : 'green')
                                    }
                                  >
                                    {item.quoteSelectedFlag === 1
                                      ? '入选'
                                      : item.quoteSelectedFlag === 0
                                        ? '未入选'
                                        : ''}
                                  </span>
                                </div>
                              </li>
                            )}
                          </ul>
                        }
                        {/* 单身自定义字段 */}
                        <BodydCustField
                          fieldSetting={fieldSetting}
                          line={item}
                          isPurchase={self.isPurchase}
                        ></BodydCustField>
                        {!self.isPurchase &&
                          detail.status === 2 &&
                          detail.confirmBiddingFlag === 1 && (
                            <div style={{ paddingTop: 20 }}>
                              <Fab
                                variant="extended"
                                color="primary"
                                size="large"
                                style={{
                                  height: 32,
                                  borderRadius: '4px'
                                }}
                                onClick={() => {
                                  setDate(item);
                                }}
                              >
                                报价
                              </Fab>

                              <a
                                className="orange fr"
                                onClick={() => {
                                  setHistoryBottom(true);
                                  setPrimaryQuoteData(item);
                                }}
                              >
                                历史价格
                              </a>
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
          {self.isPurchase && (
            <div className="m-details-item">
              <div className="details-item-title">
                <label>竞价供应商</label>
              </div>
              <div className="details-item-content">
                {!Util.isEmpty(detail.vendorList) &&
                  detail.vendorList.map((item, index) => (
                    <div className="content-line line-list-item" key={index}>
                      <div className="line-list-item-title">
                        <span>
                          {item.innerVendorCode}-{item.innerVendorName}
                        </span>
                      </div>
                      <ul className="field-list">
                        <li>
                          <span className="field-label">类型</span>
                          <div className="field-value">
                            {item.newFlag === 0
                              ? '正式供应商'
                              : item.newFlag === 2
                                ? '潜在供应商'
                                : ''}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">平台名称</span>
                          <div className="field-value">
                            {item.handshakeFlag !== 2 && item.vendorName}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">平台状态</span>
                          <div className="field-value">
                            {item.handshakeFlag === 2 ? '已加入' : '未加入'}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">竞价确认</span>
                          <div className="field-value">
                            {item.confirmBiddingFlagName}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">接收人</span>
                          <div className="field-value">
                            {item.handshakeFlag === 2
                              ? '将自动于携客平台内通知'
                              : item.contactPerson}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">手机号码</span>
                          <div className="field-value">
                            {item.mobile ? item.mobileArea : ''} {item.mobile}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">邮箱</span>
                          <div className="field-value">{item.mailbox}</div>
                        </li>
                      </ul>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      )}
      {currNavIndex === 1 && (
        <div className="order-detail-list price-compare-list">
          <ul>
            <li className="order-detail-item">
              <label className="order-detail-label">入选总金额: </label>
              <div className="order-detail-value">
                <span className="yellow">
                  {formatNumber(
                    detail.totalSelectAmount,
                    decimalPlace.Amount_Decimal_Place
                  )}
                </span>
              </div>
            </li>
          </ul>

          <ul>
            {detail.quoteCompareList &&
              detail.quoteCompareList.map((item, index) => (
                <li
                  className={
                    item.activeFlag
                      ? 'order-detail-item active'
                      : 'order-detail-item'
                  }
                  key={String(item.id) + index}
                >
                  <div
                    className="prod"
                    onClick={() => {
                      handleDrawer(item);
                    }}
                  >
                    {item.productCode}，{item.productName}，{item.productScale}
                    <i className="icon-down"></i>
                  </div>
                  <div className="price">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <span className="blue">
                              <b>
                                期望价格：
                                {formatNumber(
                                  item.expectedPrice,
                                  decimalPlace.Price_Decimal_Place
                                )}
                              </b>
                            </span>
                          </td>
                          <td>
                            <span className="green">
                              最低价：
                              {formatNumber(
                                item.minQuotePrice,
                                decimalPlace.Price_Decimal_Place
                              )}
                            </span>
                          </td>
                          <td>
                            <span>
                              平均值：
                              {formatNumber(
                                item.avgQuotePrice,
                                decimalPlace.Price_Decimal_Place
                              )}
                            </span>
                          </td>
                          <td>
                            <span className="red">
                              最高价：
                              {formatNumber(
                                item.maxQuotePrice,
                                decimalPlace.Price_Decimal_Place
                              )}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {item.activeFlag && (
                    <div className="quoProductsBox">
                      {item.quoteList &&
                        item.quoteList.map((line, idx) => (
                          <ul className="quoProductsList clearfix" key={idx}>
                            <li className="single">
                              <p className="f14">
                                {line.innerVendorName} {line.innerVendorCode}
                              </p>
                            </li>
                            <li>
                              报价金额：
                              {formatNumber(
                                line.isContainTax === 1
                                  ? line.taxPrice
                                  : line.unTaxPrice,
                                decimalPlace.Amount_Decimal_Place
                              )}
                              {line.quotePrice > item.avgQuotePrice &&
                                line.quotePrice && (
                                  <i className="icon-arrow-up red"></i>
                                )}
                              {line.quotePrice < item.avgQuotePrice &&
                                line.quotePrice && (
                                  <i className="icon-arrow-down green"></i>
                                )}
                            </li>
                            <li>
                              最近核价：
                              {formatNumber(
                                line.lastPrcPrice,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </li>
                            <li>
                              报价币别：
                              {line.quoteCurrencyName}
                            </li>
                            <li>
                              历史低价：
                              {formatNumber(
                                line.historyMinPrice,
                                decimalPlace.Amount_Decimal_Place
                              )}
                            </li>
                            <li>
                              报价税别：
                              {line.taxName}
                            </li>
                            <li>
                              降价率：
                              {line.prcDownPriceRateShow
                                ? line.prcDownPriceRateShow + '%'
                                : ''}
                            </li>
                            <li>竞价排名：{line.rank}</li>
                            <li>
                              是否采用：
                              {line.quoteSelectedFlag !== 1 &&
                                [4, 5, 7, 8].includes(detail.status) && (
                                  <span className="red">未入选</span>
                                )}
                              {line.quoteSelectedFlag === 1 &&
                                [4, 5, 7, 8].includes(detail.status) && (
                                  <span className="green">已入选</span>
                                )}
                            </li>
                            <li>备注说明：{line.vendorDescription}</li>
                            <li>中标类型：{line.selectedTypeShow}</li>
                            <li>比价说明：{line.priceCompareDesc}</li>
                            <li>采购配额：{line.purchaseRate}</li>
                          </ul>
                        ))}
                    </div>
                  )}
                </li>
              ))}
          </ul>
        </div>
      )}

      {currNavIndex ===
        ([3, 4, 5, 6, 7, 8, 9].includes(detail.status) && self.isPurchase
          ? 2
          : 1) && (
        <OrderLogList
          billNo={self.id}
          companyCode={companyCode}
          customerCode={!self.isPurchase ? detail.customerCode : undefined}
        ></OrderLogList>
      )}

      {!self.isPurchase && User.checkAuth('20050302') && (
        <Drawer
          anchor="bottom"
          open={quoteBottom}
          onClose={() => setQuoteBottom(false)}
        >
          <div tabIndex={0} role="button">
            <div className="MuiDrawer-paper">
              <div className="order-detail-list">
                <ul>
                  <li className="order-detail-item">
                    <ul className="clearfix">
                      <li className="single">
                        物料编码：{primaryQuoteData.productCode}
                      </li>
                      <li className="single">
                        物料名称：{primaryQuoteData.productName}
                      </li>
                      <li className="single">
                        物料规格：{primaryQuoteData.productScale}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="text-field-item mt15">
                <ul>
                  <li>
                    <ul className="clearfix" style={{ display: 'flex' }}>
                      <li className="w50">报价排名：{primaryQuoteData.rank}</li>
                      <li className="w50">
                        最低报价：{primaryQuoteData.currMinPrice}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="text-field-item">
                <TextField
                  label="我的报价"
                  value={myQuotePrice}
                  onChange={event => handleQuoteChange(event)}
                  margin="normal"
                  variant="outlined"
                />
                {paramVar.isBackTxtError && (
                  <div className="red">价格格式不正确</div>
                )}
                {paramVar.isBackTxtError2 && (
                  <div className="red">价格必须低于上次报价</div>
                )}
              </div>
              <div className="text-field-item">
                <FormControl fullWidth={true}>
                  <InputLabel>报价税别：</InputLabel>
                  <Select
                    value={paramVar.taxCode || ''}
                    disabled={
                      !(detail.status === 2 && detail.vendorEditTaxRateFlag)
                    }
                    onChange={event => handleTaxTypeChange(event)}
                    className="select-company-list"
                  >
                    {!Util.isEmpty(taxTypeList) &&
                      taxTypeList.map((item, index) => (
                        <MenuItem key={index} value={item.id}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
              <div className="text-field-item">
                <p>
                  <span>含税价：</span> {paramVar.quotePriceTax}
                </p>
                <p>
                  <span>未税价：</span> {paramVar.quotePriceNoTax}
                </p>
              </div>

              <div className="text-field-item">
                {/* 单身自定义字段 */}
                <BodydCustField
                  fieldSetting={fieldSetting}
                  line={paramVar}
                  bodyCustData={paramVar}
                  setBodyCustData={setParamVar}
                  isEdit={true}
                  isPurchase={self.isPurchase}
                ></BodydCustField>
              </div>

              <div className="text-field-item">
                <TextField
                  label="备注说明"
                  value={vendorDescription || ''}
                  onChange={event => handleVendorDescriptionChange(event)}
                  margin="normal"
                  rows="3"
                  multiline
                  fullWidth
                  variant="outlined"
                />
              </div>
              <p className="mt15 m-flex-box">
                <Button
                  type="default"
                  onClick={() => sureQuoteClick()}
                  className="m-flex-item u-btn u-btn_primary"
                >
                  确定
                </Button>
                <Button
                  type="default"
                  onClick={() => {
                    setParamVar({
                      quotePrice: '',
                      isBackTxtError: false,
                      isBackTxtError2: false
                    });
                    setQuoteBottom(false);
                    setMyQuotePrice('');
                  }}
                  className="m-flex-item u-btn u-btn_line"
                >
                  取消
                </Button>
              </p>
            </div>
          </div>
        </Drawer>
      )}

      {!self.isPurchase && User.checkAuth('20050302') && (
        <Drawer
          anchor="bottom"
          style={{ maxHeight: '400px' }}
          open={historyBottom}
          onClose={() => setHistoryBottom(false)}
        >
          <div tabIndex={0} role="button">
            <div className="MuiDrawer-paper">
              <div className="order-detail-list">
                <ul>
                  <li className="order-detail-item">
                    <ul className="clearfix">
                      <li>物料编码：{primaryQuoteData.productCode}</li>
                      <li>
                        <span
                          className="fr orange"
                          onClick={() => setHistoryBottom(false)}
                        >
                          <i className="icon-left"></i>
                          返回
                        </span>
                      </li>
                      <li className="single">
                        物料名称：{primaryQuoteData.productName}
                      </li>
                      <li className="single">
                        物料规格：{primaryQuoteData.productScale}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="text-field-item mt15">
                <ul>
                  <li>
                    <ul className="clearfix" style={{ display: 'flex' }}>
                      <li className="w50">报价排名：{primaryQuoteData.rank}</li>
                      <li className="w50">
                        最低报价：{primaryQuoteData.currMinPrice}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="order-detail-list">
                <ul>
                  {!Util.isEmpty(primaryQuoteData.quoteList) &&
                    primaryQuoteData.quoteList.map((quote, index) => (
                      <li
                        className="order-detail-item"
                        key={String(quote.id) + index}
                      >
                        <h4>
                          {formatDate(quote.createTime, 'YYYY-MM-DD HH:mm:ss')}
                        </h4>
                        <ul className="clearfix">
                          <li>
                            报价价格：
                            {formatNumber(
                              quote.quotePrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                          </li>
                          <li>税别：{quote.taxName}</li>
                          <li>
                            税率：{quote.taxRate ? quote.taxRate * 100 : 0}%
                          </li>
                          <li>报价人：{quote.createName}</li>
                        </ul>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </Drawer>
      )}

      {!self.isPurchase &&
        User.checkAuth('20070302') &&
        [1, 2].includes(detail.status) &&
        detail.confirmBiddingFlag === 0 && (
          <div className="wrap m-flex-box fixed-bottom">
            <Button
              type="default"
              onClick={() => {
                handle('1');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认参与
            </Button>
            <Button
              type="default"
              onClick={() => {
                handle('2');
              }}
              className="m-flex-item u-btn u-btn_line"
            >
              本次弃权
            </Button>
          </div>
        )}

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10070603') &&
            detail.status === 0 &&
            workflow.data &&
            workflow.data['bidds_publish_2'].complete && (
              <Button
                type="default"
                onClick={() => {
                  handle('3');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布
              </Button>
            )}
          {User.checkAuth('10070602') && [1, 2, 6].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handle('4');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              取消竞价
            </Button>
          )}
          {User.checkAuth('10070605') &&
            detail.status === 4 &&
            workflow.data &&
            workflow.data['bidds_cfm_5'].complete && (
              <Button
                type="default"
                onClick={() => {
                  handle('5');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布竞价结果
              </Button>
            )}
        </div>
      )}

      {/* {!self.isPurchase &&
        detail.status === 2 &&
        detail.confirmBiddingFlag === 1 && (
          <div className="wrap m-flex-box fixed-bottom">
            <Button
              type="default"
              onClick={() => {
                setQuoteBottom(true);
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              报价
            </Button>
          </div>
        )} */}

      <Modal></Modal>
    </div>
  );
}

InquiryBidMultiDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InquiryBidMultiDetail);
